import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { CommentDmListPage } from '@/features/marketing';
import {
  DEFAULT_COMMENT_DM_PERIOD,
  parseCommentDmPeriod,
  type CommentDmPeriod,
} from '@/features/marketing/comment-dm/comment-dm-results-format';

interface CommentDmSearch {
  /** Absent = this month, so a plain menu link never writes `?period=this-month`. */
  period?: CommentDmPeriod;
}

export const Route = createFileRoute('/_auth/$orgId/marketing/comment-dm')({
  // The default (or an unknown value) leaves the key out rather than `undefined`; the raw URL value can still show
  // through an omitted key, so the page re-parses on read.
  validateSearch: (search: Record<string, unknown>): CommentDmSearch => {
    const period = parseCommentDmPeriod(search.period);
    return period === DEFAULT_COMMENT_DM_PERIOD ? {} : { period };
  },
  component: CommentDmRoute,
});

function CommentDmRoute() {
  const { orgId } = Route.useParams();
  const period = Route.useSearch({ select: (search) => parseCommentDmPeriod(search.period) });
  const navigate = useNavigate({ from: '/$orgId/marketing/comment-dm' });
  return (
    <CommentDmListPage
      orgId={orgId}
      period={period}
      // A period pick replaces the history entry, so Back leaves the page instead of stepping through picks.
      onPeriodChange={(next) =>
        void navigate({ search: next === DEFAULT_COMMENT_DM_PERIOD ? {} : { period: next }, replace: true })
      }
    />
  );
}
